<template>
    <app-layout>
        <Head title="New Message"/>

        <div class="max-w-7xl mx-auto flex mb-6">
            <div class="w-full p-2 sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8 overflow-hidden relative">
                    <h2 class="text-xl mb-2">
                        <template v-if="!editMode">
                            Send A Message
                        </template>
                        <template v-else-if="editMode">
                            Edit Message
                        </template>
                    </h2>
                    <message-form 
                        :md="md"
                        @success="$emit('close')"
                    />
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import MessageForm from '@/components/MessageForm.vue';

export default {
    components: {
        MessageForm,
    },
    props: {
        md: {
            type: Object,
            default: null,
        },
    },
    computed: {
        editMode() {
            return this.md !== null;
        },
    },
};
</script>